import React, { Component } from 'react'

import { throttle } from 'lodash';
import classNames from 'classnames'

import { getViewportSize } from '../../utils/screen'
import { getDistanceFromTop, getElemPosition, getElemHeight, getElemDimensions } from '../../utils/position.js'

import './Image.css'

class Image extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoaded: false,
            progress: 0,
            containerWidth: 0,
            containerHeight: 0
        }

        this.onLoad = this.onLoad.bind(this)

        this.scroll = this.scroll.bind(this);
        this.bind = this.bind.bind(this);
        this.removeBind = this.removeBind.bind(this);
        this.getProgress = this.getProgress.bind(this);
        this.getHeight = this.getHeight.bind(this);
        this.resize = this.resize.bind(this);



    }

    onLoad() {

        
        this.setState({
            isLoaded: true
        })

        this.bind()
        
    }

    componentDidMount() {

        this.cbScroll = throttle(this.scroll)
        this.cbResize = throttle(this.resize)


        // setTimeout(this.resize, 1000)
        setTimeout(this.resize, 1000)
        

    }

    componentWillUnmount() {
        this.removeBind();
    }

    bind() {
        
        const { showBar } = this.props
        
        window.addEventListener('resize', this.cbResize)
        
        if (showBar){
            window.addEventListener('scroll', this.cbScroll)
        }
    }
    
    removeBind() {
        
        const { showBar } = this.props
        
        window.removeEventListener('resize', this.cbResize)
        
        if (showBar){
            window.removeEventListener('scroll', this.cbScroll)
        }
    }

    resize() {

        // console.log(this.el)

        const { width, height } = getElemDimensions(this.el)

        // console.log({width, height})

        this.setState({
            containerWidth: width,
            containerHeight: height
        })
    }

    scroll(e) {

        let viewport = getViewportSize()
        let scrolled = getDistanceFromTop() + viewport.height
        // let middle = scrolled - (viewport.height / 2)

        let elHeight = getElemHeight(this.el)

        let positionStart = getElemPosition(this.el).top
        let positionFinish = positionStart + elHeight


        let inView = (scrolled >= positionStart && scrolled <= positionFinish) ? true : false

        // console.log(inView)

        if (inView) {

            let p = scrolled - positionStart
            let progress = Math.floor(p / elHeight * 100)

            this.setState({
                progress
            })

        }

    }


    getProgress(progress, total = 1) {

        const margin = total + (total / 100 * -progress)

        return margin
    }


    getHeight(width, height) {

        const { containerWidth } = this.state

        

        if (containerWidth > width) {
            return height
        }

        const newHeight = (containerWidth / width) * height

        return newHeight
    }


    render() {


        const { data, showBar } = this.props
        const { title, file } = data.fields



        const { isLoaded, progress } = this.state

        const imageStyle = {
            opacity: isLoaded ? 1 : 0
        }

        const containerStyles = {
            // height: this.getHeight(width, height)
        }

        const containerClasses = classNames({
            image: true,
            'text-center': true,
            showBar: showBar
        })

        const progressValue = this.getProgress(progress)

        const barStyle = {
            transform: `scaleY(${progressValue})`,
            // opacity: progressValue
        }

        return (

            <div className={containerClasses} ref={(el) => { this.el = el }} style={containerStyles}>
                {showBar &&
                    <div className="bar" style={barStyle}></div>
                }
                <img src={file.url} alt={title} style={imageStyle} onLoad={this.onLoad} />
            </div>


        );
    }
}


export default Image;